import { useLocation } from "react-router-dom";
import { useAbout, useHome, useServices } from "../api/queries";

function isHomeRoute(pathname) {
  return pathname === "/";
}

export function useSiteAbout(options = {}) {
  const { pathname } = useLocation();
  const onHome = isHomeRoute(pathname);
  const home = useHome({ enabled: onHome, ...options });
  const about = useAbout({ enabled: !onHome, ...options });

  return onHome ? home : about;
}

export function useSiteAboutData(options = {}) {
  const { pathname } = useLocation();
  const onHome = isHomeRoute(pathname);
  const home = useHome({ enabled: onHome, ...options });
  const about = useAbout({ enabled: !onHome, ...options });

  return {
    data: onHome ? home.data?.about : about.data,
    isLoading: onHome ? home.isLoading : about.isLoading,
    error: onHome ? home.error : about.error,
  };
}

export function useSiteServicesData(options = {}) {
  const { pathname } = useLocation();
  const onHome = isHomeRoute(pathname);
  const home = useHome({ enabled: onHome, ...options });
  const services = useServices({ enabled: !onHome, ...options });

  return {
    data: onHome ? home.data?.services : services.data,
    isLoading: onHome ? home.isLoading : services.isLoading,
    error: onHome ? home.error : services.error,
  };
}

export function useSiteClients(options = {}) {
  const { pathname } = useLocation();
  const onHome = isHomeRoute(pathname);
  const home = useHome({ enabled: onHome, ...options });
  const about = useAbout({ enabled: !onHome, ...options });

  const clients = onHome
    ? home.data?.about?.clients ?? []
    : about.data?.clients ?? [];

  return {
    clients,
    isLoading: onHome ? home.isLoading : about.isLoading,
  };
}
